import React, { useState } from "react";
import axios from "axios";
import { Button, EmptyState, Icon, Modal, toast } from "@axum/ax-design";
import { BASE_URL } from "../../../redux/actions/dashboard/env.variables";
import { Audit } from "../../../types/orders/audit";
import { LogsTable } from "./styles";

// Chrome corta la fecha en los guiones: en celular sólo puede pasar la hora al renglón de abajo.
const dateParts = (date: string) => date.split(" ").map((part, i) => (
  <React.Fragment key={i}>{i > 0 && " "}<span className="o360-log-date-part">{part}</span></React.Fragment>
));

const downloadJsonFile = (jsonDebugInfo: string) => {
  const blob = new Blob([jsonDebugInfo], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "data.json";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const useOrderLogs = () => {
  const [logsOrder, setLogsOrder] = useState<any>(null);
  const [audits, setAudits] = useState<Audit[]>([]);

  const showLogs = (order: any) => {
    const endpoint = BASE_URL + `/api/Orders/OrdersAudits?orderId=${order.id}`;
    const userStr = localStorage.getItem("user") as string || "";
    if (userStr.length < 1)
      throw new Error("Not Authorized");
    const user = JSON.parse(userStr);

    const config: any = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "content-type": "application/json",
        "Authorization": `Bearer ${user.token}`
      }
    };
    axios.get(endpoint, config)
      .then(res => {
        if (res.status !== 200) throw new Error(`Failed to get audits ${res.statusText}`);
        return res.data;
      })
      .then((auditsResponse: Audit[]) => {
        setAudits(auditsResponse);
        setLogsOrder(order);
      })
      .catch(err => {
        console.error(err);
        toast.show("No se pudieron traer los logs de la orden", { type: "danger" });
      });
  };

  const logsModal = (
    <Modal
      open={logsOrder !== null}
      onClose={() => setLogsOrder(null)}
      title="Logs de la orden"
      subtitle={logsOrder ? `${logsOrder.axumOperationType} ${logsOrder.id}` : undefined}
      size="lg"
    >
      {audits.length === 0 ? (
        <EmptyState icon={<Icon name="list" />} title="La orden no tiene logs" />
      ) : (
        <LogsTable className="ax-table">
          <thead>
            <tr>
              <th className="o360-log-date">Fecha</th>
              <th className="ax-text-start">Mensaje</th>
              <th className="o360-log-action" aria-label="Acciones" />
            </tr>
          </thead>
          <tbody>
            {audits.map((audit, i) => (
              <tr key={i}>
                <td className="ax-font-tabular o360-log-date">{dateParts(audit.date)}</td>
                <td className="ax-text-start o360-log-message">{audit.auditMessage}</td>
                <td className="o360-log-action">
                  {audit.jsonDebugInfo && (
                    <Button size="sm" variant="ghost" aria-label="Descargar JSON" onClick={() => downloadJsonFile(audit.jsonDebugInfo)}>
                      <Icon name="download" /><span className="o360-log-action-label">Descargar JSON</span>
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </LogsTable>
      )}
    </Modal>
  );

  return { showLogs, logsModal };
};
